import { Point } from 'generated/graphql'
import { useCallback, useState } from 'react'

export interface Bounds {
  boundsBottomLeft: Point
  boundsTopRight: Point
  zoomLevel: number
}

const useMapBounds = (map?: null | google.maps.Map<Element>) => {
  const [bounds, setBounds] = useState<Bounds>({
    boundsBottomLeft: {
      latitude: 0,
      longitude: 0
    },
    boundsTopRight: {
      latitude: 0,
      longitude: 0
    },
    zoomLevel: 16
  })

  const updateBounds = useCallback(() => {
    if (!map) {
      return
    }

    const bounds = map.getBounds()

    if (!bounds) {
      return
    }

    const northEast = bounds.getNorthEast()
    const southWest = bounds.getSouthWest()

    const boundsTopRight: Point = {
      latitude: northEast.lat(),
      longitude: northEast.lng()
    }

    const boundsBottomLeft: Point = {
      latitude: southWest.lat(),
      longitude: southWest.lng()
    }

    const zoomLevel = map.getZoom()

    setBounds(current => ({
      ...current,
      boundsBottomLeft,
      boundsTopRight,
      zoomLevel
    }))
  }, [map])

  return { bounds, updateBounds } as const
}

export default useMapBounds
